export var WEBSOCKET_ACTIONS;
(function (WEBSOCKET_ACTIONS) {
    WEBSOCKET_ACTIONS["AuthRequest"] = "authentication-request";
    WEBSOCKET_ACTIONS["Authenticate"] = "authenticate";
    WEBSOCKET_ACTIONS["Heartbeat"] = "heartbeat";
    WEBSOCKET_ACTIONS["AutomergeInit"] = "automerge-init";
    WEBSOCKET_ACTIONS["AutomergeSync"] = "automerge-sync";
    WEBSOCKET_ACTIONS["UpdateUsers"] = "users-update";
    WEBSOCKET_ACTIONS["InactiveSocket"] = "ws-closing-inactivity";
    WEBSOCKET_ACTIONS["Ping"] = "ping";
    WEBSOCKET_ACTIONS["Pong"] = "pong";
})(WEBSOCKET_ACTIONS || (WEBSOCKET_ACTIONS = {}));
export class WebSocketWrapper extends EventTarget {
    _ws;
    _msgListeners = {};
    _isPongEnabled = true;
    constructor(url, projectId, env, token) {
        super();
        this.addMessageListener(WEBSOCKET_ACTIONS.AuthRequest, () => {
            this.send(WEBSOCKET_ACTIONS.Authenticate, { projectId, env, token });
        });
        this.addMessageListener(WEBSOCKET_ACTIONS.Ping, () => {
            if (this._isPongEnabled)
                this.send(WEBSOCKET_ACTIONS.Pong);
        });
        this.connect(url);
    }
    connect(url) {
        if (typeof url === 'undefined') {
            throw ('Unable to connect as socket URL is undefined');
        }
        this._ws = new WebSocket(url);
        this._ws.addEventListener('open', () => {
            console.log('Connected to WebSocket');
            this.dispatchEvent(new CustomEvent('open', { detail: this }));
        });
        this._ws.addEventListener('close', (ev) => {
            console.warn('Disconnected from WebSocket:', ev.wasClean, ev.code, ev.reason);
            this.dispatchEvent(new CustomEvent('close', { detail: ev }));
        });
        this._ws.addEventListener('error', (ev) => {
            console.warn('WebSocket error:', ev);
            this.dispatchEvent(new CustomEvent('error', { detail: ev }));
        });
        this._ws.addEventListener('message', (ev) => {
            if (!ev.data || typeof ev.data !== 'string') {
                throw (`Invalid websocket message: ${ev.data}`);
            }
            const msg = JSON.parse(ev.data.toString());
            if (typeof this._msgListeners[msg.action] !== 'undefined') {
                for (const callback of this._msgListeners[msg.action]) {
                    callback(msg.payload);
                }
            }
        });
    }
    async waitUntilReady() {
        if (this._ws?.readyState === WebSocket.OPEN)
            return;
        return new Promise((resolve) => {
            this._ws?.addEventListener('open', () => resolve());
        });
    }
    get isOpen() {
        return this._ws?.readyState === WebSocket.OPEN;
    }
    get isClosedOrClosing() {
        return this._ws ? [WebSocket.CLOSED, WebSocket.CLOSING].includes(this._ws.readyState) : false;
    }
    async send(action, payload) {
        if (payload instanceof Uint8Array) {
            payload = Array.from(payload);
        }
        return this._ws?.send(JSON.stringify({ action, payload }));
    }
    async broadcast(action, payload) {
        return this._ws?.send(JSON.stringify({ action, payload, broadcast: true }));
    }
    addMessageListener(action, callback) {
        if (typeof this._msgListeners[action] === 'undefined') {
            this._msgListeners[action] = [callback];
        }
        else {
            this._msgListeners[action].push(callback);
        }
    }
    removeMessageListenersForAction(action) {
        delete this._msgListeners[action];
    }
    enablePong() {
        this._isPongEnabled = true;
    }
    disablePong() {
        this._isPongEnabled = false;
    }
    close() {
        this.disablePong();
        return new Promise((resolve) => {
            if (typeof this._ws === 'undefined')
                return resolve();
            if (this._ws.readyState !== WebSocket.OPEN)
                return resolve();
            this._ws.addEventListener('close', () => resolve());
            this._ws.close();
        });
    }
}
